// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionReason-cls1__da3f713bf6e76a7a85bc{/*!*/}.SuggestionReason-cls2__e39463d750e17799de77{display:block}@media(min-width: 768px){.SuggestionReason-cls2__e39463d750e17799de77{display:inline-block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionReason-cls1__da3f713bf6e76a7a85bc",
	"cls2": "SuggestionReason-cls2__e39463d750e17799de77 SuggestionReason-cls1__da3f713bf6e76a7a85bc"
};
export default ___CSS_LOADER_EXPORT___;
